module.exports = __webpack_public_path__ + "img/alisa@2x.ff0d9dd.png";